import en from './locales/en.json';
import ru from './locales/ru.json';
import ka from './locales/ka.json';
import type { WebsiteLanguage } from '../../utils/websiteSsr/contract';

export interface ContentSection {
  title: string;
  paragraphs?: string[];
  items?: Array<{ title: string; text: string }>;
  bullets?: string[];
}
export type SectionKey = keyof typeof en.sections;
export type ContentBook = Omit<typeof en, 'sections'> & {
  sections: Record<SectionKey, ContentSection>;
};
export const contentBooks: Record<WebsiteLanguage, ContentBook> = { en, ru, ka };
export function getContentBook(language: string): ContentBook {
  return contentBooks[language.startsWith('ru') ? 'ru' : language.startsWith('ka') ? 'ka' : 'en'];
}
